<template>
  <div class="school content">
     <div class="head">
        专业排行
     </div>
     <div class="yuanxiaoku-sch-list-page">
        <div class="yuanxiaoku-sch-list-pages">
           <el-form :model="query" inline>
              <el-form-item label="院校名称">
                 <el-input placeholder="请输入" v-model="query.collegeName"></el-input>
              </el-form-item>
              <el-form-item label="专业名称">
                <el-input placeholder="请输入" v-model="query.majorName"></el-input>
              </el-form-item>
              <el-form-item label="专业等级">
                <el-select placeholder="请选择" v-model="level">
                  <el-option
                        v-for="item in levelArr"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                      </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button type="success" @click="search">检索</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}" v-loading="loading">
              <el-table-column prop="collegeName" label="院校名称" align="center">
              </el-table-column>
              <el-table-column v-for="(item,i) in levelArr" v-if="item.id==query.level" :key="i" :label="item.title + '专业'" align="center">
                 <template slot-scope='scope'>
                   <span>
                     {{scope.row[item.major]}}
                   </span>
                 </template>
              </el-table-column>
            </el-table>

            <div style="width: 100%;margin-top: 20px;margin-bottom:20px;display: flex;align-items: center;justify-content: center;">
              <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="query.page"
                    :page-sizes="[20,50,100,120]"
                    :page-size="query.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                  </el-pagination>
            </div>
        </div>
     </div>
  </div>
</template>

<script>
  import { zhuangyePai } from "@/api/gw/major.js"
  export default {
    data(){
      return{
        loading:false,
        query:{
          collegeName:"",//院校名称
          page:1,
          limit:20,
          majorName:"",//专业名称
          level:"ajia",//等级
        },
        list:[],
        level:"ajia",
        levelArr:[
          {id:"ajia",title:"A+",major:"ajia_major"},{id:"a_s",title:"A",major:"as_major"},{id:"a_jian",title:"A-",major:"a_jian_major"},
          {id:"b_jia",title:"B+",major:"b_jia_major"},{id:"b_ma",title:"B",major:"b_majors"},{id:"b_jian",title:"B-",major:"b_jian_major"},
          {id:"c_jia",title:"C+",major:"c_jia_major"},{id:"c_mas",title:"C",major:"c_major"},{id:"c_jian",title:"C-",major:"c_jian_major"},
        ],
        total:0,
      }
    },
    mounted(){
       this.zhuangyePai();
    },
    methods:{
      zhuangyePai(){
        this.loading = true
        this.query["level"] = this.level
        zhuangyePai(this.query).then(res=>{
          this.total = res.data.total
          this.list = res.data.data
          console.log("专业排名",res.data);
        }).finally(()=>{
          this.loading = false
        })
      },
      search(){
        this.query.page = 1
        this.zhuangyePai();
      },
      handleSizeChange(val) {
        this.limit = val
        this.zhuangyePai()
      },
      handleCurrentChange(val) {
        this.page = val
        this.zhuangyePai()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sch-level{
    margin-top: 10px;
    color: #666666;
        height: 22px;
        display: flex;
        align-items: center;
        width: fit-content;
  }
  .lists{
    width:100%;
    display: flex;
    flex-wrap: wrap;
    .item-depart-title{
      color: #999999;
    }
    .col-line{
          color: #E7E7E7;
              padding: 0 10px;
    }
    .address{
      margin-top: 7px;
      color: #666666;
          height: 22px;
          display: flex;
          align-items: center;
          width: fit-content;
          .dingwei{
            width: 20px;
            height: 20px;
            margin-right:5px;
          }
    }
    .listcon{
      .info-box{
        flex: 1;
        font-size: 14px;
        .sch-title{
              display: flex;
              align-items: center;
              justify-content: space-between;
                  font-size: 16px;
                  line-height: 26px;
                  height: 26px;
        }
      }
      .logo{
            display: block;
            width: 68px;
            height: 68px;
            margin-right: 16px;
            img{
              width:100%;
              height: 100%;
              border-radius: 50%;
            }
      }
          box-sizing: border-box;
          padding: 20px 29px 22px;
          display: flex;
          align-items: center;
          width: calc(50% - 10px);
          background: #FFFFFF;
          margin-top: 20px;
          position: relative;
          margin-bottom: 20px;
    }
    .listcon:nth-child(2n){
      margin-left: auto;
    }
  }
  .list{
    width:1250px;
    margin:0 auto;
    min-height: 300px;
  }
  .item-options{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        color: #333333;
  }
  .span{
    margin-right: 20px;margin-bottom: 10px;cursor: pointer;
  }
  .spanselect{
    color: #1CB278!important;
    font-weight: bold;
  }
  .span:hover{
    color: #1CB278!important;
  }
  .pri01{
    width: 84px;

    margin-right: 22px;
    color: #7B7B7B;
  }
  .pro{
    display: flex;
    flex-wrap: wrap;
  }
  .yuanxiaoku-sch-list-page{
    .yuanxiaoku-sch-list-pages{
      width: 1180px;
      margin: 0 auto;
    }
      width:1250px;
      margin: 0 auto;
      padding-top: 20px;
      padding-bottom: 20px;
      background: #FFFFFF;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
  }
.school{
  width: 100%;
  .head{
    width: 100%;
    height: 148px;
    background: linear-gradient(180deg,#49c48d,#1cb278);
    background: url(../../assets/yuanxiaoku.jpg) no-repeat;
    background-size: 100%;
    line-height: 148px;
    text-align: center;
    font-size: 38px;
    font-weight: 600;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/majorSeat/index.vue